export const assetChainModules = {
  assets: true,
  uniques: true,
};
